<mat-sidenav-container
  class="mainWrapper blue_theme  light-theme"
  autosize
  autoFocus
  dir="ltr"
>
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->

  <mat-sidenav
    #leftsidenav
    [mode]="isOver ? 'over' : 'side'"
    [opened]="!isOver"
    (openedChange)="onSidenavOpenedChange($event)"
    (closedStart)="onSidenavClosedStart()"
    class="sidebarNav"
  >
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper">
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->

    <app-header
      [showToggle]="!isOver"
      (toggleCollapsed)="toggleCollapsed()"
      (toggleMobileNav)="sidenav.toggle()"
    ></app-header>

    <main class="pageWrapper">
      <app-breadcrumb></app-breadcrumb>
      <!-- ============================================================== -->
      <!-- Outlet -->
      <!-- ============================================================== -->
      <router-outlet></router-outlet>
    </main>
    <div class="whatsapp-box" *ngIf="showWhastapp">
      <a
        href="https://wa.me/5561986460803/?text=Olá Bonn App, preciso de suporte no gerenciamento da minha conta."
        target="_blank"
        matTooltip="Fale conosco pelo WhatsApp"
      >
        <img src="/assets/images/logos/logo-whatsapp-branca.png" />
      </a>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
